<!--
* @Name：流程审批-退回
* @Author: 刘玉
* @Date: 2021-12-17 16:56:42
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-17 16:56:42
-->
<template>
  <div class="component-overlay">
    <van-nav-bar
      class="text-font-normal"
      title="退回"
      left-arrow
      left-text="关闭"
      @click-left="onClickLeft"
      :fixed="true"
    />
    <van-form ref="form" class="approval-info">
      <van-field
        class="text-font-normal"
        v-model="form.newActivityName"
        is-link
        readonly
        label="退回节点"
        placeholder="请选择退回节点"
        @click="showPicker = true"
        :rules="[{ required: true, message: '退回节点为必填项' }]"
      />
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker
          title="节点"
          class="text-font-normal"
          show-toolbar
          :columns="form.nodeArray"
          value-key="name"
          @cancel="showPicker = false"
          @confirm="changeConfirm"
        />
      </van-popup>

      <van-field label="处理人" class="text-font-normal">
        <template #input>
          <van-tag
            style="padding: 2px; font-size: 17px"
            type="success"
            v-if="singleUserData != null && singleUserData.id != null"
          >
            {{ singleUserData.name }}</van-tag
          >
        </template>
      </van-field>
      <van-field
        class="text-font-normal"
        label="备注/意见"
        v-model="form.option"
        placeholder="请输入备注/意见"
        :autosize="{ minHeight: 100, maxHeight: 100 }"
        type="textarea"
        :rules="[{ required: true, message: '备注/意见为必填项' }]"
      />
    </van-form>
    <div style="text-align: center">
      <van-button size="normal" @click="cancel">取消</van-button>
      <van-button type="info" size="normal" style="margin-left: 10px" @click="confirm">确定</van-button>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import { getBackNode, getBackNodeUser } from '@/api/process'
export default {
  name: 'BackToNode',
  data() {
    return {
      form: {
        nodeArray: [],
        operate: 'backToNode',
        priority: '50',
        taskTitle: null
      },
      singleUserData: {},
      showPicker: false
    }
  },
  props: {
    taskId: {
      type: String,
      required: true,
      default: ''
    },
    taskTitle: {
      type: String,
      required: true,
      default: ''
    }
  },
  mounted() {
    this.form.taskId = this.taskId
    this.form.taskTitle = this.taskTitle
    this.getBackNode()
  },
  methods: {
    async getBackNode() {
      try {
        const response = await getBackNode(this.taskId)
        if (response && response.code === 0) {
          this.form.nodeArray = response.data
          if (this.form.nodeArray && this.form.nodeArray.length > 0) {
            this.form.newActivityId = this.form.nodeArray[0].id
            this.form.newActivityName = this.form.nodeArray[0].name
            await this.backToNodeChange(this.form.newActivityId)
          }
        }
      } catch (e) {
        console.error(e)
      }
    },
    async backToNodeChange(nodeId) {
      const response = await getBackNodeUser(this.taskId, nodeId)
      if (response && response.code === 0) {
        if (response.data && response.data.length > 0) {
          if (response.data[0].assigneeName && response.data[0].assignee) {
            this.singleUserData = {
              id: response.data[0].assignee,
              name: response.data[0].assigneeName
            }
            this.form.usersInfo = this.singleUserData
          } else {
            this.singleUserData = {}
            this.form.usersInfo = {}
          }
        } else {
          this.singleUserData = {}
          this.form.usersInfo = {}
        }
      }
    },
    changeConfirm(val) {
      this.form.newActivityId = val.id
      this.form.newActivityName = val.name
      this.showPicker = false
    },
    confirm() {
      this.$refs.form.validate().then(() => {
        const data = cloneDeep(this.form)
        delete data.nodeArray
        delete data.usersInfo
        data.userId = this.singleUserData.id
        data.userName = this.singleUserData.name
        this.$emit('confirm', data)
      })
    },
    cancel() {
      this.$emit('cancel')
    },
    onClickLeft() {
      this.$emit('cancel')
    }
  }
}
</script>
